// Версия приложения
// Обновляется автоматически при каждом изменении кода
export const APP_VERSION = '1.0.8';
export const APP_BUILD_DATE = '2026-01-02'; // YYYY-MM-DD
